import themeColors from "assets/theme/colors.js";
const componentStyles = (theme) => ({
  listItemRoot: {
    width: "auto",
    fontSize: "0.875rem",
    color: themeColors.bsColors.LightGray,
    "&:hover": {
      color: themeColors.white.main,
    },
  },
  copyrightWrapper: {
    color: themeColors.gray[600],
    fontSize: "1rem",
    textAlign: "center",
    [theme.breakpoints.up("md")]: {
      textAlign: "left",
    },
  },
  copyrightLink: {
    fontWeight: "600",
    marginLeft: ".25rem",
    color: themeColors.white.main,
    backgroundColor: "initial",
    textDecoration: "none",
    "&:hover": {
      color: themeColors.bsColors.LogoLightBlue,
    },
  },
  justifyContentCenter: {
    [theme.breakpoints.down("lg")]: {
      justifyContent: "center!important",
    },
  },
  flexDirectionColumn: {
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column!important",
    },
  },
});

export default componentStyles;
